import { FILTERS_DEBOUNCE_MS } from 'app/constants'
import { useDebounce } from './use-debounce'
import { useUrlFilters } from './use-url-filters'

// Filters for API requests and query keys: several quick checkbox clicks produce one request
export const useDebouncedUrlFilters = () => {
  const { urlFilters } = useUrlFilters()

  return useDebounce(urlFilters, FILTERS_DEBOUNCE_MS)
}
